/*
  schema_sha256: 4ebae48603b21baed9ac5a4975a2769f5ac24d37200ae42390a38824f5192206
  artifact_sha256: 3d3f2b62ebc3e847da098a1918df8b13a4239e8c3dfc91d799ead5bdabd0d530
  zoolander_commit: 7e9213ef92452b23b25e680b1dc1320ebf4cd24c

  DO NOT MANUALLY MODIFY THIS FILE
  This file is auto generated by: pay js:run generate-schema
*/

const CURRENT_PINNED_VERSION = '2026-09-21-19.internal';

export default CURRENT_PINNED_VERSION;

export const VERIFICATION_MODE = false;
